import { render, staticRenderFns } from "./ViewStorageLocation.vue?vue&type=template&id=3938aae2&scoped=true&"
import script from "./ViewStorageLocation.vue?vue&type=script&lang=js&"
export * from "./ViewStorageLocation.vue?vue&type=script&lang=js&"
import style0 from "./ViewStorageLocation.vue?vue&type=style&index=0&id=3938aae2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3938aae2",
  null
  
)

export default component.exports